<template>
  <div class="SpeedConsumption flex-jc-bt">
    <div class="flex-60 left-side">
      <SpCard custom-class="sp-color-bg-4 card-content">
        <div class="fs-int item">
          <div class="flex-jc-end">
            <span v-title class="fs-bold">{{ $l('OilCategory') }}</span>
          </div>
          <div class="border-box flex-al-center flex-jc-end item">
            <span v-title class="flex-30 fs-int pd-r-20 text-right">{{ $l('FO') }}</span>
            <SpSelect v-model="shipInfo.oilFoTypeId" type="warn4" :height="28" class="flex-30">
              <SpSelectOption v-for="(item, key) in shipOil['fo']" :key="item.id" :label="item.name" :value="item.id" />
            </SpSelect>
          </div>
          <div class="border-box flex-al-center flex-jc-end item">
            <span v-title class="flex-30 fs-int pd-r-20 text-right">{{ $l('DO') }}</span>
            <SpSelect v-model="shipInfo.oilDoTypeId" type="warn4" :height="28" class="flex-30">
              <SpSelectOption v-for="(item, key) in shipOil['do']" :key="item.id" :label="item.name" :value="item.id" />
            </SpSelect>
          </div>
          <div class="border-box flex-al-center flex-jc-end item">
            <span v-title class="flex-30 fs-int pd-r-20 text-right">{{ $l('Other') }}</span>
            <SpInput v-model="shipInfo.oilOther" :validate-reg="/^((?=.[a-zA-Z])[A-Za-z0-9-.,\/()&’” ]{3,64})?$/" type="warn4" :height="28" class="flex-30" />
          </div>
        </div>
        <div class="flex-jc-end item tb-gap">
          <div class="flex-85 flex-jc-bt">
            <div class="flex-65">
              <div class="fs-int">{{ $l('MainEngineType') }}</div>
              <SpInput v-model="shipInfo.mainEngine" :validate-reg="/^((?=.*[a-zA-Z])[A-Za-z0-9-+=—.,\/()&:’”%@\s]{7,511})?$/" class="mg-t-10" type="warn" text-type="textarea" row="2" />
              <div class="flex-jc-bt item">
                <div class="flex-30">
                  <SpIcon type="doubleSelect" />
                </div>
                <div class="flex-30">
                  <SpIcon type="doubleSelect" />
                </div>
              </div>
              <div class="flex-jc-bt item">
                <div class="fs-bold-1 italic title">{{ $l('AtSea') }}</div>
                <div class="flex-30">
                  <div class="fs-int text-center">{{ $l('LadenSailing') }}</div>
                  <div class="flex-jc-bt item unit">
                    <div class="flex-30 text-center">{{ $l('FO') }}</div>
                    <div class="flex-30 text-center">{{ $l('DO') }}</div>
                  </div>
                  <div class="item text-center unit">{{ $l('MTDay') }}</div>
                </div>
                <div class="flex-30">
                  <div class="fs-int text-center">{{ $l('BallastSailing') }}</div>
                  <div class="flex-jc-bt item unit">
                    <div class="flex-30 text-center">{{ $l('FO') }}</div>
                    <div class="flex-30 text-center">{{ $l('DO') }}</div>
                  </div>
                  <div class="item text-center unit">{{ $l('MTDay') }}</div>
                </div>
              </div>

              <div v-for="mode in shipWorkingMode['sailing']" class="flex-jc-bt item tb-gap">
                <div class="pd-r-20 title">
                  <div class="fs-int text-right">{{ mode.name }}</div>
                  <div class="flex-al-center flex-jc-end">
                    <SpInput v-model="shipInfo.oilConsumptions.main.laden[mode.id].sailingSpeed"
                             :max="20" :min="2" :precision="2" text-type="number"
                             type="warn4" width="100" :height="28" class="flex-40" />
                    <span class="unit">{{ $l('Knots') }}</span>
                  </div>
                </div>
                <div class="flex-30 flex-jc-bt">
                  <SpInput v-model="shipInfo.oilConsumptions.main.laden[mode.id].foCostRate" name="" class="flex-48" type="warn" />
                  <SpInput v-model="shipInfo.oilConsumptions.main.laden[mode.id].doCostRate" class="flex-48" type="warn" />
                </div>
                <div class="flex-30 text-right">
                  <div class="fs-int">{{ mode.name }}</div>
                  <div class="flex-al-center flex-jc-end">
                    <SpInput v-model="shipInfo.oilConsumptions.main.ballast[mode.id].sailingSpeed"
                             :max="20" :min="2" :precision="2" text-type="number"
                             type="warn4" width="100" :height="28" class="flex-40" />
                    <span class="unit">{{ $l('Knots') }}</span>
                  </div>
                </div>
                <div class="flex-30 flex-jc-bt">
                  <SpInput v-model="shipInfo.oilConsumptions.main.ballast[mode.id].foCostRate"
                           :max="70" :min="0" :precision="2" text-type="number"
                           class="flex-48" type="warn" />
                  <SpInput v-model="shipInfo.oilConsumptions.main.ballast[mode.id].doCostRate"
                           :max="70" :min="0" :precision="2" text-type="number"
                           class="flex-48" type="warn" />
                </div>
              </div>
            </div>
            <div class="flex-30">
              <div class="fs-int">{{ $l('AuxiliaryEngineType') }}</div>
              <SpInput v-model="shipInfo.auxiliaryEngine" :validate-reg="/^((?=.[a-zA-Z])[A-Za-z0-9-+=—.,\/()&:’”%@\s]{7,127})?$/" class="mg-t-10" type="warn" text-type="textarea" row="2" />
              <div class="flex-jc-end item">
                <div class="flex-80">
                  <SpIcon type="doubleSelect" />
                </div>
              </div>
              <div class="flex-jc-end item">
                <div class="flex-80">
                  <div class="fs-int text-center">
                    &nbsp;
                  </div>
                  <div class="flex-jc-bt item unit">
                    <div class="flex-30 text-center">{{ $l('FO') }}</div>
                    <div class="flex-30 text-center">{{ $l('DO') }}</div>
                  </div>
                  <div class="item text-center unit">{{ $l('MTDay') }}</div>
                </div>
              </div>
              <div v-for="mode in shipWorkingMode['sailing']" class="flex-jc-end tb-gap">
                <div class="flex-80 flex-jc-bt">
                  <SpInput v-model="shipInfo.oilConsumptions.auxiliaries.sailing[mode.id].foCostRate"
                           :max="70" :min="0" :precision="2" text-type="number"
                           class="flex-48" type="warn" />
                  <SpInput v-model="shipInfo.oilConsumptions.auxiliaries.sailing[mode.id].doCostRate"
                           :max="70" :min="0" :precision="2" text-type="number"
                           class="flex-48" type="warn" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-jc-end item tb-gap">
          <div class="flex-85 flex-jc-bt flex-no-wrap">
            <div class="flex-30 sp-color-11 text-left tip">{{ $l('tip') }}</div>
            <div class="flex-70">
              <div class="flex-al-center flex-jc-end item">
                <div v-title class="border-box flex-50 fs-bold-1 italic mg-r-10 text-right">{{ $l('AtPortAnchorage') }}</div>
                <div class="flex-30">
                  <div class="flex-jc-bt item unit">
                    <div class="flex-30 text-center">{{ $l('FO') }}</div>
                    <div class="flex-30 text-center">{{ $l('DO') }}</div>
                  </div>
                  <div class="item text-center unit">{{ $l('MTDay') }}</div>
                </div>
              </div>
              <div v-for="mode in shipWorkingMode['parked']" class="flex-al-center flex-jc-end item">
                <div v-title class="border-box flex-50 fs-int mg-r-10 text-right">{{ mode.name }}</div>
                <div class="flex-30">
                  <div class="flex-jc-bt">
                    <SpInput v-model="shipInfo.oilConsumptions.auxiliaries.parked[mode.id].foCostRate"
                             :max="70" :min="0" :precision="2" text-type="number"
                             class="flex-48" type="warn" />
                    <SpInput v-model="shipInfo.oilConsumptions.auxiliaries.parked[mode.id].doCostRate"
                             :max="70" :min="0" :precision="2" text-type="number"
                             class="flex-48" type="warn" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </SpCard>
      <p class="reminder">{{ $l('Reminder') }}</p>
    </div>
    <div class="flex-38 mg-t-40 right-side sp-color-bg-4">
      <ShipInfoTable v-model="shipInfo" />
      <div class="fs-int outer-gap sp-color-11 text-left">{{ $l('SomeSupportingFilesPictures') }}</div>
      <div class="fs-int mg-t-20 opacity-50 sp-color-11 text-left">{{ $l('Picturesofenginerelatedtothisship') }}</div>
      <SpUploadGroup class="mg-t-20" :business-id="shipInfo.businessId" file-type="ship/machine/engine" accept="image/*" />
      <div class="fs-int mg-t-20 opacity-50 sp-color-11 text-left">{{ $l('Others') }}</div>
      <SpUploadGroup class="mg-t-20" :business-id="shipInfo.businessId" file-type="ship/machine/other" accept="MIME_type" />
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import SpCard from '@/components/common/SpCard'
import SpInput from '@/components/common/SpInput'
import SpSelect from '@/components/common/SpSelect'
import SpUploadGroup from '@/components/common/SpUploadGroup'
import SpIcon from '@/components/common/SpIcon'
import ShipInfoTable from '@/components/shipOwner/tonnages/newTonnage/ShipInfoTable'
import { getShipOilApi, getShipSpeedApi, getShipWorkingModeApi } from '@/request/APIs/so'
import SpSelectOption from '@/components/common/SpSelectOption'
export default {
  name: 'SpeedConsumption',

  nameSpace: 'shipOwner.tonnages.newTonnage.SpeedConsumption',

  components: {
    SpSelectOption,
    SpCard,
    SpInput,
    SpSelect,
    SpUploadGroup,
    SpIcon,
    ShipInfoTable
  },

  props: {
    modelValue: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },

  emits: ['update:modelValue'],

  data () {
    return {
      shipOil: {},
      shipWorkingMode: {},
      shipSpeed: {}
    }
  },

  computed: {
    shipInfo: {
      get () {
        return this.modelValue
      },

      set (nv) {
        this.$emit('update:modelValue', nv)
      }
    }
  },

  created () {
    this.getShipOil()
    this.getShipWorkingMode()
    this.getShipSpeed()
  },

  mounted () {
  },

  methods: {
    // 获取油类选项
    getShipOil () {
      getShipOilApi().then(res => {
        this.shipOil = res.data
      })
    },

    // 获取运行模式选项
    getShipWorkingMode () {
      getShipWorkingModeApi().then(res => {
        this.shipWorkingMode = res.data
        if (!this.shipInfo.id) { this.formatOilConsumptions(res.data) }
      })
    },

    // 获取主机航速选项
    getShipSpeed () {
      getShipSpeedApi().then(res => {
        this.shipSpeed = res.data
      })
    },

    formatOilConsumptions (shipWorkingMode) {
      const parkedKeys = Object.keys(shipWorkingMode['parked'])
      const sailingKeys = Object.keys(shipWorkingMode['sailing'])
      sailingKeys.forEach(sk => {
        this.shipInfo.oilConsumptions.main.laden[shipWorkingMode['sailing'][sk].id] = {
          workingModeId: shipWorkingMode['sailing'][sk].id,
          sailingSpeed: '',
          foCostRate: '',
          doCostRate: ''
        }
        this.shipInfo.oilConsumptions.main.ballast[shipWorkingMode['sailing'][sk].id] = {
          workingModeId: shipWorkingMode['sailing'][sk].id,
          sailingSpeed: '',
          foCostRate: '',
          doCostRate: ''
        }
        this.shipInfo.oilConsumptions.auxiliaries.sailing[shipWorkingMode['sailing'][sk].id] = {
          workingModeId: shipWorkingMode['sailing'][sk].id,
          foCostRate: '',
          doCostRate: ''
        }
      })

      parkedKeys.forEach(pk => {
        this.shipInfo.oilConsumptions.auxiliaries.parked[shipWorkingMode['parked'][pk].id] = {
          workingModeId: shipWorkingMode['parked'][pk].id,
          foCostRate: '',
          doCostRate: ''
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.SpeedConsumption{
  .card-content{
    padding: @gap;
    .tb-gap{
      margin:@gap*2 0 @gap 0 !important;
    }
    .item,.tb-gap{
      position: relative;
      .title{
        position: absolute;
        padding-right: @gap;
        left: 0;
        top: 0;
        transform: translateX(-100%);
      }
    }
    .tip{
      font-size: 12px;
      font-family: Arial;
      font-weight: 400;
      opacity: 0.5;
    }
  }
  .right-side{
    box-sizing:border-box;
    padding:@gap;
  }
  .outer-gap{
    margin-top: @gap*3;
  }
}
</style>
